import { jsx as _jsx } from "react/jsx-runtime";
// ---Third-party imports
import React, { createContext, useContext } from 'react';
// ---Framework imports
import { Actions } from 'uix/registries';
import { useState, useVlmState } from 'uix/hooks';
const WIKI_STATE_DEFAULT = {
    otid: null,
    datatype: null,
    text: null,
    mimetype: null
};
const VlmContext = /*#__PURE__*/ createContext({});
export const useVlmContext = ()=>useContext(VlmContext);
export const VlmWikiStateProvider = ({ children })=>{
    let [toData, setToData] = useState(WIKI_STATE_DEFAULT);
    let send_toData = toData === WIKI_STATE_DEFAULT ? null : toData;
    let fromData = useVlmState('wikiControl', send_toData) || WIKI_STATE_DEFAULT;
    let ctx = {
        // otid, text, mimetype, datatype
        ...fromData,
        setWikiState: (text, mimetype)=>setToData({
                ...toData,
                text,
                mimetype,
                otid: fromData.otid
            })
    };
    return /*#__PURE__*/ _jsx(VlmContext.Provider, {
        value: ctx,
        children: children
    });
};
